import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form, ModalItem, FormItem, ButtonItem,
    InputItem, InputNumberItem, DatePickerItem, ErrorItem,
    TablaEditor
} from "../../../../Components/Items";

class AgregarTabla extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        visible: this.props.visible,
        columnas: [],
        filas: [],
    };

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            this.setState({ visible: this.props.visible, columnas: [], filas: [] });
        }
    }

    onFinishFailed(e) { ErrorItem(e); }

    onEditorChange({ columnas, filas }) {
        this.setState({ columnas, filas });
    }

    onFinish(values) {
        if (!values?.nombre) return message.info("Proporcione el nombre de la tabla");
        if (this.state.columnas.length === 0) return message.info("Agrega al menos una columna");

        const filas = this.state.filas.map(({ key, ...f }) => f);

        this.setState({ loading: true });
        axios
            .post(
                "tablas/agregarTabla",
                { ...values, columnas: this.state.columnas, filas, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Tabla agregada exitosamente");
                    this.cerrarModal();
                } else if (res.data.success === 1) {
                    message.error("No se pudo agregar la tabla");
                } else {
                    message.error("Sucedió un error y no se pudo agregar la tabla");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModal = () => {
        this.setState({ visible: false, columnas: [], filas: [] });
        this.props.cerrarAgregarTabla();
        if (this.formRef.current) this.formRef.current.resetFields();
    };

    render() {
        return (
            <ModalItem
                title="Agregar Tabla"
                visible={this.state.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModal}
                width={1000}
            >
                <Form
                    ref={this.formRef}
                    name="modalAgregarTabla"
                    layout
                    bottom={
                        <ButtonItem type="primary" htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                            loading={this.state.loading}>
                            Guardar
                        </ButtonItem>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormItem name="nombre" label="Nombre" required margin>
                        <InputItem placeholder="Ej: ISR 2024, Subsidio al Empleo 2024" />
                    </FormItem>

                    <FormItem name="nombreFormula" label="Nombre Fórmula" margin
                        tooltip="Sin espacios ni caracteres especiales. Ej: ISR_2024">
                        <InputItem
                            placeholder="Ej: ISR_2024"
                            style={{ fontFamily: "monospace" }}
                            onChange={(e) => {
                                const limpio = e.target.value.replace(/[^a-zA-Z0-9_]/g, "");
                                this.formRef.current.setFieldsValue({ nombreFormula: limpio });
                            }}
                        />
                    </FormItem>

                    <FormItem name="descripcion" label="Descripción" margin>
                        <InputItem placeholder="Descripción opcional" />
                    </FormItem>

                    <FormItem name="ejercicio" label="Ejercicio" margin>
                        <InputNumberItem placeholder="Ej. 2024" min={2000} max={2100} />
                    </FormItem>

                    <FormItem name="fechaInicioVigencia" label="Inicio de Vigencia" margin>
                        <DatePickerItem placeholder="Informativo" style={{ width: "100%" }} />
                    </FormItem>

                    <FormItem name="fechaFinVigencia" label="Fin de Vigencia" margin>
                        <DatePickerItem placeholder="Informativo" style={{ width: "100%" }} />
                    </FormItem>
                </Form>

                <div style={{ marginTop: 16 }}>
                    <TablaEditor
                        columnas={this.state.columnas}
                        filas={this.state.filas}
                        onChange={this.onEditorChange.bind(this)}
                    />
                </div>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarTabla);